import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import uuid from "react-uuid";
import cloneDeep from "lodash.clonedeep";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  advertisersList: [],
  advertiserDetails: {
    name: "",
    account_id: "",
    email: "",
    revenue_share: "",
    margin: "",
    emailReports: "",
    emailReportType: "",
    emailReportTimezone: "",
    hasReportingPending: false,
    frequency_capping: "",
    click_frequency_capping: "",
    conv_frequency_capping: "",
    complete_frequency_capping: "",
    win_frequency_capping: "",
    target_adv_pubs: "",
  },
  advertiserFilterFormValues: {
    organizations: [],
    accounts: [],
    advertisers: [],
  },
  advertiserFilters: {
    organizations: [],
    accounts: [],
    advertisers: [],
  },
};

export const GetAllAdvertisersListThunk = createAsyncThunk(
  "advertiser/GetAllAdvertisersListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var userProfile = payload?.authUserData?.user_assoc_profiles;
    var advertiserFilters = payload?.advertiserFilters;
    let condition = [];

    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      let suffix = "";
      if (advertiserFilters?.organizations.length > 0) {
        suffix = "adv.";
      }
      condition.push(
        suffix +
          "name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%'"
      );
    }

    if (advertiserFilters?.organizations.length > 0) {
      condition.push(
        "adv.`accountid`=acc.id AND acc.company_id IN ('" +
          advertiserFilters?.organizations.join("','") +
          "')"
      );
      if (advertiserFilters?.accounts.length > 0) {
        condition.push(
          "adv.accountid IN ('" + advertiserFilters?.accounts.join("','") + "')"
        );
      }

      if (advertiserFilters?.advertisers.length > 0) {
        //let advStr = "'"+campaignFilters.advertisers.join("','")+"'";
        condition.push(
          "adv.id IN ('" + advertiserFilters?.advertisers.join("','") + "')"
        );
      } else if (isSysAdmin != 1) {
        if (
          userProfile.includes("advertiser") &&
          payload?.authUserData.user_assoc_advertisers.length > 0
        ) {
          condition.push(
            "adv.id IN ('" +
              payload.authUserData.user_assoc_advertisers.join("','") +
              "')"
          );
        } else {
          condition.push("adv.id IN ('0')");
        }
      }
      condition.push("adv.active in ('0','1')");
    } else {
      if (advertiserFilters?.accounts.length > 0) {
        condition.push(
          "accountid IN ('" + advertiserFilters?.accounts.join("','") + "')"
        );
      }

      if (advertiserFilters?.advertisers.length > 0) {
        //let advStr = "'"+campaignFilters.advertisers.join("','")+"'";
        condition.push(
          "id IN ('" + advertiserFilters?.advertisers.join("','") + "')"
        );
      } else if (isSysAdmin != 1) {
        if (
          userProfile.includes("advertiser") &&
          payload?.authUserData.user_assoc_advertisers.length > 0
        ) {
          condition.push(
            "id IN ('" +
              payload.authUserData.user_assoc_advertisers.join("','") +
              "')"
          );
        } else {
          condition.push("id IN ('0')");
        }
      }
      condition.push("active in ('0','1')");
    }

    let where = "";
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }
    let query = "";
    if (advertiserFilters?.organizations.length > 0) {
      query =
        "SELECT adv.id,adv.name,adv.accountid,adv.email,adv.rev_share,adv.creation_date,adv.active,acc.company as account_name FROM " +
        tablePrefix +
        "advertisers AS adv," +
        tablePrefix +
        "accounts AS acc " +
        where +
        " order by creation_date desc";
    } else {
      query =
        "select id,name,email,accountid,rev_share,creation_date,active,(select company from " +
        tablePrefix +
        "accounts where id=accountid ) as account_name from " +
        tablePrefix +
        "advertisers " +
        where +
        " order by creation_date desc";
    }

    const queryBody = {
      queries: [
        {
          // query:
          //   "select id,name,email,accountid,rev_share,creation_date,active,(select company from " +
          //   tablePrefix +
          //   "accounts where id=accountid ) as account_name from " +
          //   tablePrefix +
          //   "advertisers " +
          //   where +
          //   " order by creation_date desc",
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateAdvertiserDetailsThunk = createAsyncThunk(
  "advertiser/InsertUpdateAdvertiserDetailsThunk",
  async (payload) => {
    let insertUpdateQuery = "";

    if (payload.action == "add") {
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "advertisers (id,name,accountid,email,rev_share,margin,days_email_report,email_report_type,daily_email_report_timezone_country,creation_date,created_by,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,win_frequency_capping,target_adv_pubs) values('" +
        payload.id +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload.account_id +
        "','" +
        addslashes(payload.email) +
        "','" +
        payload.rev_share +
        "','" +
        payload.margin +
        "','" +
        payload.email_report +
        "','" +
        payload.email_report_type +
        "','" +
        payload.report_timezone_country +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",'" +
        payload.created_by +
        "','" +
        payload.frequency_capping +
        "','" +
        payload.click_frequency_capping +
        "','" +
        payload.conv_frequency_capping +
        "','" +
        payload.complete_frequency_capping +
        "','" +
        payload.win_frequency_capping +
        "','" +
        payload.target_adv_pubs +
        "'" +
        ") ";
    } else {
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "advertisers set name='" +
        addslashes(payload.name) +
        "',accountid='" +
        payload.account_id +
        "',email='" +
        addslashes(payload.email) +
        "',rev_share='" +
        payload.rev_share +
        "',margin='" +
        payload.margin +
        "',days_email_report='" +
        payload.email_report +
        "',email_report_type='" +
        payload.email_report_type +
        "',daily_email_report_timezone_country='" +
        payload.report_timezone_country +
        "',frequency_capping='" +
        payload.frequency_capping +
        "',click_frequency_capping='" +
        payload.click_frequency_capping +
        "',conv_frequency_capping='" +
        payload.conv_frequency_capping +
        "' ,complete_frequency_capping='" +
        payload.complete_frequency_capping +
        "' ,win_frequency_capping='" +
        payload.win_frequency_capping +
        "',target_adv_pubs='" +
        payload.target_adv_pubs +
        "'   where id='" +
        payload.id +
        "'";
    }
    const queryBody = {
      queries: [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "advertisers",
            columns:
              "id,name,accountid,email,rev_share,margin,days_email_report,email_report_type,daily_email_report_timezone_country,created_by,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,win_frequency_capping,target_adv_pubs",
            id: payload.id,
            user_details: payload.user_details,
            context: "advertisers",
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetPublisherAccountsThunk = createAsyncThunk(
  "advertiser/GetPublisherAccountsThunk",
  async (payload) => {
    let condition = "";
    if (payload?.accounts.length > 0) {
      condition = "where id IN ('" + payload?.accounts.join("','") + "')";
    }
    const queryBody = {
      queries: [
        {
          query:
            "select id as value,name,company from " +
            tablePrefix +
            "accounts " +
            condition,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAdvertiserDetailsThunk = createAsyncThunk(
  "advertiser/GetAdvertiserDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,accountid,email,rev_share,margin,days_email_report,email_report_type,daily_email_report_timezone_country,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,win_frequency_capping,target_adv_pubs from " +
            tablePrefix +
            "advertisers where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select id from " +
            tablePrefix +
            " audience_jobs where lookup_key='" +
            payload.id +
            "' and status='pending' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateAdvertiserStatusThunk = createAsyncThunk(
  "advertiser/UpdateCompanyStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "advertisers set active='" +
            payload.status +
            "' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "advertisers",
            columns: "active",
            id: payload.id,
            user_details: payload.user_details,
            context: "advertisers",
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const AddRunAdvertiserThunk = createAsyncThunk(
  "advertiser/AddRunAdvertiserThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "insert into  " +
            tablePrefix +
            "audience_jobs (id,code,lookup_key,custom_data,status,created_by,creation_date) values('" +
            uuid() +
            "','" +
            payload.code +
            "','" +
            payload.id +
            "','" +
            payload.custom_data +
            "','pending','" +
            payload.created_by +
            "'," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ")",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const Advertiser = createSlice({
  name: "advertiser",
  initialState,
  reducers: {
    resetAdvertiserForm(state, action) {
      state.advertiserDetails = {
        name: "",
        account_id: "",
        email: "",
        revenue_share: "",
        margin: "",
        emailReports: "",
        emailReportType: "",
        emailReportTimezone: "",
        hasReportingPending: false,
        frequency_capping: "",
        click_frequency_capping: "",
        conv_frequency_capping: "",
        complete_frequency_capping: "",
        win_frequency_capping: "",
        target_adv_pubs: "",
      };
    },
    updateAdvertiserFiltersFormValues(state, action) {
      let advertiserFilters = cloneDeep(state.advertiserFilterFormValues);
      if (action.payload?.action == "delete") {
        advertiserFilters = {
          organizations: [],
          accounts: [],
          advertisers: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        advertiserFilters[type] = data;
      }

      state.advertiserFilterFormValues = advertiserFilters;
    },
    updateAdvertiserFilters(state, action) {
      let advertiserFilters = cloneDeep(state.advertiserFilters);
      advertiserFilters.organizations = action.payload.organizations;
      advertiserFilters.accounts = action.payload.accounts;
      advertiserFilters.advertisers = action.payload.advertisers;

      state.advertiserFilters = advertiserFilters;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllAdvertisersListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllAdvertisersListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0]) {
          state.advertisersList = action.payload.data.results[0];
        }
        state.loading = false;
      })
      .addCase(GetAllAdvertisersListThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(InsertUpdateAdvertiserDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        InsertUpdateAdvertiserDetailsThunk.fulfilled,
        (state, action) => {
          if (!action.payload.data?.error) {
            let advertiserData = {
              name: action.meta.arg.name,
              account_id: action.meta.arg.account_id,
              email: action.meta.arg.email,
              margin: action.meta.arg.margin,
              revenue_share: action.meta.arg.rev_share,
              emailReports: action.meta.arg.email_report,
              emailReportType: action.meta.arg.email_report_type,
              emailReportTimezone: action.meta.arg.report_timezone_country,
              hasReportingPending: action.meta.arg.run_now,
              frequency_capping: action.meta.arg.frequency_capping,
              click_frequency_capping: action.meta.arg.click_frequency_capping,
              conv_frequency_capping: action.meta.arg.conv_frequency_capping,
              complete_frequency_capping:
                action.meta.arg.complete_frequency_capping,
              win_frequency_capping: action.meta.arg.win_frequency_capping,
              target_adv_pubs: action.meta.arg.target_adv_pubs,
            };
            state.advertiserDetails = advertiserData;
          }
          state.loading = false;
        }
      )
      .addCase(InsertUpdateAdvertiserDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetAdvertiserDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAdvertiserDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let advertiserData = {
            name: resultData.name,
            account_id: resultData.accountid,
            email: resultData.email,
            revenue_share: resultData.rev_share,
            margin: resultData.margin,
            emailReports: resultData.days_email_report,
            emailReportType: resultData.email_report_type,
            emailReportTimezone: resultData.daily_email_report_timezone_country,
            hasReportingPending:
              action.payload.data?.results[1].length > 0 ? true : false,
            frequency_capping: resultData.frequency_capping,
            click_frequency_capping: resultData.click_frequency_capping,
            conv_frequency_capping: resultData.conv_frequency_capping,
            complete_frequency_capping: resultData.complete_frequency_capping,
            win_frequency_capping: resultData.win_frequency_capping,
            target_adv_pubs: resultData.target_adv_pubs,
          };
          state.advertiserDetails = advertiserData;
        }
        state.loading = false;
      })
      .addCase(GetAdvertiserDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateAdvertiserStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateAdvertiserStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let advertiserList = state.advertisersList;
          let advId = action.meta.arg.id;
          let status = String(action.meta.arg.status);
          if (status == "2") {
            advertiserList = advertiserList.filter((item) => item.id !== advId);
          } else {
            advertiserList.map((advinfo) => {
              if (advinfo.id == advId) {
                advinfo.active = status;
              }
              return advinfo;
            });
          }
          state.advertisersList = advertiserList;
        }
        state.loading = false;
      })
      .addCase(UpdateAdvertiserStatusThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(AddRunAdvertiserThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddRunAdvertiserThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
        }
        state.loading = false;
      })
      .addCase(AddRunAdvertiserThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetPublisherAccountsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPublisherAccountsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
        }
        state.loading = false;
      })
      .addCase(GetPublisherAccountsThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
const { actions, reducer } = Advertiser;
// Extract and export each action creator by name
export const {
  resetAdvertiserForm,
  updateAdvertiserFiltersFormValues,
  updateAdvertiserFilters,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
